import $ from 'jquery';
import 'slick-carousel';

$(document).ready(function () {
  // get all the carousels on the page.
  let carousels = $("[data-carousel-enabled='true']");

  // loop through all carousels.
  carousels.each(function (index, $val) {
    const carouselData = $val.dataset;
    let $stage = `#product-stage__${carouselData.carouselId}`;
    let $thumbs = `#product-thumbs__${carouselData.carouselId}`;

    // The stage carousel, controlled by the thumbnail carousel.
    $($stage).slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      centerMode: true,
      fade: true,
      asNavFor: $thumbs,
    });

    // Thumbnail carousel, which navigates the stage carousel also.
    $($thumbs).slick({
      slidesToShow: 3,
      slidesToScroll: 1,
      dots: false,
      centerMode: true,
      focusOnSelect: true,
      centerPadding: '0px',
      arrows: true,
      asNavFor: $stage,
    });

  });
});
